export default __webpack_public_path__ + "static/media/tete76.8b1051ae.png";